// Centralized Axios instance - uses localhost in development, can be overridden with env variable
import axios from 'axios';
import { API_BASE_URL } from '../config/apiConfig';

const api = axios.create({
  baseURL: API_BASE_URL,
});

export default api;
